// AUTO-GENERATED SQL Builder (V40 Final) for SlotOption
import { 
  SqlField, 
  SqlExp, 
  SqlExpChain, 
  SqlFn, 
  SqlLiteral, 
  SqlSubQuery, 
  SqlApplyColumn, 
  SqlNavHybrid, 
  createNavHybrid 
} from '../utils/sql-core';
import { SqlAst } from '../utils/sql-ast';

export class SlotOptionSql {
  private ast = new SqlAst('SlotOption', 'slotOption');
  public readonly main: any = {};

  public guid: SqlField;
  public offeringSlotId: SqlField;
  public kind: SqlField;
  public offeringId: SqlField;
  public sellPrice: SqlField;
  public createdByUser: SqlNavHybrid;
  public offering: SqlNavHybrid;
  public offeringSlot: SqlNavHybrid;
  public updatedByUser: SqlNavHybrid;
  public bookingSlotSelectionList: SqlNavHybrid;
  public id: SqlField;
  public isDeleted: SqlField;
  public createdBy: SqlField;
  public createdDate: SqlField;
  public updatedBy: SqlField;
  public updatedDate: SqlField;

  constructor() {
    this.guid = new SqlField('slotOption', 'guid', '', 'id', 'slotOption_guid');
    this.offeringSlotId = new SqlField('slotOption', 'offeringSlotId', 'offeringSlot', 'id', 'slotOption_offeringSlot');
    this.kind = new SqlField('slotOption', 'kind', '', 'id', 'slotOption_kind');
    this.offeringId = new SqlField('slotOption', 'offeringId', 'offering', 'id', 'slotOption_offering');
    this.sellPrice = new SqlField('slotOption', 'sellPrice', '', 'id', 'slotOption_sellPrice');
    this.createdByUser = createNavHybrid('slotOption', 'slotOption_createdByUser', 'User');
    this.offering = createNavHybrid('slotOption', 'slotOption_offering', 'Offering');
    this.offeringSlot = createNavHybrid('slotOption', 'slotOption_offeringSlot', 'OfferingSlot');
    this.updatedByUser = createNavHybrid('slotOption', 'slotOption_updatedByUser', 'User');
    this.bookingSlotSelectionList = createNavHybrid('slotOption', 'slotOption_bookingSlotSelectionList', 'BookingSlotSelection');
    this.id = new SqlField('slotOption', 'id', '', 'id', 'slotOption_id');
    this.isDeleted = new SqlField('slotOption', 'isDeleted', '', 'id', 'slotOption_isDeleted');
    this.createdBy = new SqlField('slotOption', 'createdBy', '', 'id', 'slotOption_createdBy');
    this.createdDate = new SqlField('slotOption', 'createdDate', '', 'id', 'slotOption_createdDate');
    this.updatedBy = new SqlField('slotOption', 'updatedBy', '', 'id', 'slotOption_updatedBy');
    this.updatedDate = new SqlField('slotOption', 'updatedDate', '', 'id', 'slotOption_updatedDate');

    for (const k of Object.keys(this)) {
      const v = (this as any)[k];
      if (v instanceof SqlField) this.main[k] = v;
    }
  }

  // SELECT
  select(fn:(x:SlotOptionSql)=>any) {
    this.ast.addSelectObject(fn(this));
    return this;
  }

  // WHERE
  where(fn:(x:SlotOptionSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  and(fn:(x:SlotOptionSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  or(fn:(x:SlotOptionSql)=>SqlExp | SqlExpChain) {
    this.ast.addOr(fn(this));
    return this;
  }

  // JOIN
  join(fn:(x:SlotOptionSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f);
    return this;
  }
  leftJoin(fn:(x:SlotOptionSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'LEFT');
    return this;
  }
  rightJoin(fn:(x:SlotOptionSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'RIGHT');
    return this;
  }

  // AND JOIN
  andJoin(fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    const last = this.ast.joins[this.ast.joins.length - 1];
    if (!last) throw new Error('andJoin() before join()');

    const left = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(this.ast.alias, prop)
    });
    const right = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(last.alias, prop)
    });

    const exp = (this.ast as any).compileExp(fn(left, right));

    if (typeof last.on === 'string') {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[
          { column:last.on, operator:'', value:null, isTrusted:true, subFilters:[] },
          exp
        ]
      };
    }
    else if (last.on.logic === 'And') {
      last.on.subFilters.push(exp);
    }
    else {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[ last.on, exp ]
      };
    }

    return this;
  }

  // CTE
  with(name:string, fn:(c:any)=>any) {
    this.ast.with(name, fn);
    return this;
  }
  withRecursive(name:string, fn:(c:any)=>any) {
    this.ast.withRecursive(name, fn);
    return this;
  }

  // CTE JOIN
  joinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.joinCTE(name, alias, fn);
    return this;
  }
  fullJoinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.fullJoinCTE(name, alias, fn);
    return this;
  }

  // SUBQUERY
  subQuery(fn:(b:any)=>any) {
    return new SqlSubQuery(fn);
  }

  // APPLY
  apply(name:string, fn:(b:any)=>any) {
    this.ast.apply(name, fn);
    return this;
  }
  applyColumn(name:string, fn:(b:any)=>SqlField) {
    return this.ast.applyColumn(name, fn);
  }
  crossApply(app:any) {
    this.ast.crossApply(app);
    return this;
  }

  // GROUP BY
  groupBy(fn:(x:SlotOptionSql)=>SqlField[]) {
    this.ast.addGroup(fn(this));
    return this;
  }

  // HAVING
  having(fn:(x:SlotOptionSql)=>SqlExp | SqlExpChain) {
    this.ast.addHaving(fn(this));
    return this;
  }

  // ORDER
  orderBy(fn:(x:SlotOptionSql)=>any[]) {
    this.ast.addOrder(fn(this));
    return this;
  }

  // UNION
  union(fn:(q:any)=>any) {
    this.ast.union(fn);
    return this;
  }
  unionAll(fn:(q:any)=>any) {
    this.ast.unionAll(fn);
    return this;
  }

  limit(n:number) { this.ast.take = n; return this; }
  offset(n:number) { this.ast.skip = n; return this; }

  build() {
    return this.ast.toQueryDescriptor();
  }
}
